import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { DataGrid, GridColDef, Paper, Typography, TypographyProps } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { HealthcheckRowData } from '../types'
import { HealthcheckAssigneeCell } from './HealthcheckAssigneeCell'
import { HealthcheckStatusCell } from './HealthcheckStatusCell'
import { HealthcheckTaskCell } from './HealthcheckTaskCell'
import { useHealthcheckRowsData } from './useHealthcheckRowsData'
import { ASSIGNMENT_ENABLED } from './config'

const getHeader = ({ variant = 'subtitle2', ...props }: TypographyProps) => {
  const Header = () => <Typography variant={variant} {...props} />
  return Header
}
interface OrgHealthcheckDataGridProps {
  org: OrganizationDetailFragment
}

export const OrgHealthcheckDataGrid = ({ org }: OrgHealthcheckDataGridProps) => {
  const healthcheckRows = useHealthcheckRowsData(org)
  const isOnboarded = org.isOnboarded

  const columns: GridColDef<HealthcheckRowData>[] = [
    {
      field: 'status',
      headerName: '',
      width: 60,
      sortable: false,
      filterable: false,
      renderCell: (params) => <HealthcheckStatusCell row={params.row} />,
    },
    {
      field: 'task',
      width: 400,
      flex: 1,
      sortable: false,
      filterable: false,
      renderHeader: getHeader({ children: isOnboarded ? 'Status' : 'Task' }),
      renderCell: (params) => <HealthcheckTaskCell row={params.row} />,
    },
  ]

  if (!isOnboarded && org.onboardingWorkflow && ASSIGNMENT_ENABLED) {
    columns.push({
      field: 'assignee',
      headerAlign: 'right',
      width: 180,
      sortable: false,
      filterable: false,
      renderHeader: getHeader({ children: 'Assignee' }),
      renderCell: (params) => <HealthcheckAssigneeCell row={params.row} />,
    })
  }
  return (
    <Paper>
      <DataGrid
        rows={healthcheckRows}
        columns={columns}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        hideFooter
        scrollbarSize={0}
        getRowId={(row) => row.id}
        sx={{
          '& .MuiDataGrid-columnHeaders [role=row]': {
            height: '2.5rem !important',
          },
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-scrollbar': {
            display: 'none',
          },
        }}
      />
    </Paper>
  )
}
